module.exports = __webpack_public_path__ + "static/media/handshake_series3.96fa7259.webp";